import * as React from 'react';
export const CharismaUserContext = React.createContext(null);